import { predicates } from '../predicates/index';
import { selectors } from '../selectors/index';
import { TRAFFIC_SOURCES } from '../constants';

export const trPartner = {
  rule: predicates.and(
    predicates.searchParamEqualsValue('utm_medium', 'tr_partner'),
    predicates.searchParamsIncludeKey('utm_source'),
  ),
  extractor: (traffic) => {
    const trafficSource = TRAFFIC_SOURCES.PARTNER;
    const trafficId = selectors.searchParamValue(traffic, 'utm_source');

    return {
      trafficSource,
      trafficId,
    };
  },
};
